/* U7 PRODUCT NOTICE — blocks checkout until the shopper accepts the notice.
   Guards the cart page (#checkout) and the cart drawer (#CartDrawer-Checkout).

   Acceptance is held in sessionStorage: Dawn re-renders the cart footer and the
   drawer on every quantity change, which would otherwise wipe a ticked box and
   silently re-lock checkout. It clears when the browser session ends, so each
   new visit must accept again. */
(function () {
  var KEY = 'u7:product-notice-accepted';
  var CHECKOUT = '#checkout, #CartDrawer-Checkout, [name="checkout"]';

  function isAccepted() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function setAccepted(value) {
    try { value ? sessionStorage.setItem(KEY, '1') : sessionStorage.removeItem(KEY); } catch (e) {}
  }
  function notices() { return document.querySelectorAll('[data-u7-notice]'); }

  function apply() {
    var list = notices();
    if (!list.length) return; /* empty cart — the notice isn't rendered, leave buttons alone */
    var ok = isAccepted();

    list.forEach(function (notice) {
      var box = notice.querySelector('[data-u7-notice-accept]');
      if (box && box.checked !== ok) box.checked = ok;
      notice.classList.toggle('is-accepted', ok);
      if (ok) hideError(notice);
    });

    document.querySelectorAll(CHECKOUT).forEach(function (btn) {
      btn.disabled = !ok;
      btn.setAttribute('aria-disabled', String(!ok));
    });
  }

  function hideError(notice) {
    var err = notice.querySelector('[data-u7-notice-error]');
    if (err) err.hidden = true;
  }

  /* /cart renders the notice twice (page footer + the drawer markup in the layout),
     so flag the one belonging to the form the shopper actually submitted. */
  function reject(context) {
    var notice = document.querySelector('[data-u7-notice][data-context="' + context + '"]') || notices()[0];
    if (!notice) return;
    var err = notice.querySelector('[data-u7-notice-error]');
    if (err) err.hidden = false;
    notice.classList.add('is-rejected');
    setTimeout(function () { notice.classList.remove('is-rejected'); }, 1200);
    notice.scrollIntoView({ block: 'center', behavior: 'smooth' });
    var box = notice.querySelector('[data-u7-notice-accept]');
    if (box) box.focus();
  }

  document.addEventListener('change', function (event) {
    var box = event.target.closest && event.target.closest('[data-u7-notice-accept]');
    if (!box) return;
    setAccepted(box.checked);
    apply();
  });

  /* Belt and braces: the checkout buttons are form submits, so a keyboard Enter
     inside the cart form could still post without ever hitting the button. */
  document.addEventListener(
    'submit',
    function (event) {
      if (!notices().length || isAccepted()) return;
      var form = event.target;
      if (!form || (form.id !== 'cart' && form.id !== 'CartDrawer-Form')) return;
      var submitter = event.submitter;
      if (submitter && submitter.name !== 'checkout') return; /* quantity/update posts stay allowed */
      event.preventDefault();
      reject(form.id === 'CartDrawer-Form' ? 'drawer' : 'cart');
    },
    true
  );

  /* Dawn swaps cart markup in on quantity changes; re-assert the lock afterwards.
     Trailing debounce, not leading: a re-render arrives as a burst of mutations,
     and running on the first one could re-tick markup that is then replaced —
     leaving an unticked box next to an unlocked checkout button.
     Only childList is observed, so apply()'s own attribute writes can't loop. */
  var timer = null;
  var observer = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(apply, 60);
  });

  function start() {
    apply();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
